{
  "version": 1,
  "fallback": "community",
  "settings": [
    { "id": "community", "labels": { "de": "Realistisch", "en": "Realistic" }, "order": 0, "enabled": true },
    { "id": "fantasy", "labels": { "de": "Fantasy", "en": "Fantasy" }, "order": 1, "enabled": true }
  ]
}
